module.exports = __webpack_public_path__ + "img/Loading_r_18.f7595d1b.png";